import axios from "axios";
import { storage } from "../../../helpers";
import { API_URL } from "../../../config";
import { LABEL, MESSAGE } from "../../../constants";

export const exportPdfRequest = async (id, forModal = false) => {
    const token = storage.getToken();
  
    try {
      const response = await axios.get(`${API_URL}/documents/${id}/pdf`, {
        responseType: "arraybuffer",
        headers: {
          Accept: "application/pdf",
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (forModal) {
        console.log("Returning PDF data for modal");
        return response.data;
      } else {
        const blob = new Blob([response.data], { type: "application/pdf" });
  
        const contentDisposition = response.headers['content-disposition'];
        const fileNameMatch = contentDisposition?.match(/filename="(.+?)"/);
        const fileName = fileNameMatch ? fileNameMatch[1] : `Document_${id}.pdf`;
  
        const url = window.URL.createObjectURL(blob);
  
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName; 
        link.click();
  
        window.URL.revokeObjectURL(url);
  
        console.log("PDF downloaded successfully");
      }
    } catch (error) {
      console.error(MESSAGE.PDF_EXPORT.error, error);
      throw error;
    }
  };
  